/** Utility to get query status from object returned by RTK Query useQuery
 * @param isLoading returned from useQuery
 * @param isFetching returned from useQuery
 * @param isError returned from useQuery
 * @param error returned from useQuery
 * @param data returned from useQuery
 */
export function getQueryStatus({ isLoading, isFetching, isError, error, data, }) {
    if (isError)
        return { status: "ERROR", error: error };
    if (isLoading)
        return { status: "LOADING" };
    if (isFetching)
        return { status: "FETCHING" };
    if (!error && data !== undefined)
        return { status: "SUCCESS" };
    return { status: "UNKNOWN" };
}
export const calculatePaginationOffset = (pagination) => {
    return pagination.itemsPerPage * (pagination.currentPage - 1);
};
export const convertSortToQueryString = (sort) => {
    return `${sort.reverse ? "-" : "+"}${sort.property}`;
};
//# sourceMappingURL=services.js.map